import { render, staticRenderFns } from "./card-widget.vue?vue&type=template&id=228afde5&scoped=true&"
import script from "./card-widget.vue?vue&type=script&lang=js&"
export * from "./card-widget.vue?vue&type=script&lang=js&"
import style0 from "./card-widget.vue?vue&type=style&index=0&id=228afde5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228afde5",
  null
  
)

export default component.exports